export enum CoordinationErrorCodeType {
    CurrentUserNotACoordinationUser = 'CurrentUserNotACoordinationUser',
    UnauthorizedCoordinationClaim = 'UnauthorizedCoordinationClaim',
    OrganizationNotFound = 'OrganizationNotFound',
    CoordinationNotFound = 'CoordinationNotFound',
    UnavailableCoordinationUrlName = 'UnavailableCoordinationUrlName',
    InvalidCoordinationUrlName = 'InvalidCoordinationUrlName',
    InvalidCoordinationName = 'InvalidCoordinationName'
}
